import { ofType, Epic } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import { get, getForMinorToken, post } from '__utils/ajax-wrapper';
import { FluxStandardAction } from '__utils/type';
import { ENDPOINTS } from 'constants/endpoints';
import * as Actions from 'constants/actions';
import * as LoginActions from './login.actions';
import resolveURLParams from '__utils/url-params-resolver';

export const getCurrentUserEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_CURRENT_USER),
        mergeMap(() => {
            return get(ENDPOINTS.GET_CURRENT_USER, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) {
                        return LoginActions.fetchGetCurrentUserSuccess(response.response);
                    } else {
                        return LoginActions.fetchGetCurrentUserError(response.response);
                    }
                }),
                catchError(error => of(LoginActions.fetchGetCurrentUserError(error)))
            );
        })
    );
};

export const getCheckMobileNumber: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_CHECK_MOBILE_NUMBER),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_CHECK_MOBILE_NUMBER, action.payload, null), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response.response.operationMessage === 'success') {
                        return LoginActions.fetchGetCheckMobileNumberSuccess(response.response.responseData);
                    } else if (response.status === 200 && response.response.operationMessage === 'failure' && response.response.errorEnum === 'USER_MAPPED_TO_OTHER_AGENT') {
                        return LoginActions.setUserMappedToOtherAgent(true);
                    } else {
                        return LoginActions.fetchGetCheckMobileNumberError(response.response);
                    }
                }),
                catchError(error => of(LoginActions.fetchGetCheckMobileNumberError(error)))
            );
        })
    );
};

export const postVerifyPassword: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_VERIFY_PASSWORD),
        mergeMap((action) => {
            return post(resolveURLParams(ENDPOINTS.POST_VERIFY_PASSWORD, action.payload, null), action.payload, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) { 
                        return LoginActions.fetchVerifyPasswordSuccess(response.response);
                    } else {
                        return LoginActions.fetchVerifyPasswordError(response.response);
                    }
                }),
                catchError(error => of(LoginActions.fetchVerifyPasswordError(error)))
            );
        })
    );
};

export const postSendLoginOtp: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_LOGIN_OTP),
        mergeMap((action) => {
            return post(resolveURLParams(ENDPOINTS.POST_SEND_LOGIN_OTP, action.payload, null), action.payload, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) {
                        return LoginActions.fetchSendLoginOtpSuccess();
                    } else {
                        return LoginActions.fetchSendLoginOtpError();
                    }
                }),
                catchError(error => of(LoginActions.fetchSendLoginOtpError()))
            );
        })
    );
};

export const postVerifyLoginOtp: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_POST_VERIFY_LOGIN_OTP),
        mergeMap((action) => {
            return post(resolveURLParams(ENDPOINTS.POST_VERIFY_LOGIN_OTP, action.payload, null), action.payload, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response.response.operationMessage === 'success') {
                        return LoginActions.fetchVerifyLoginOtpSuccess();
                    } else {
                        return LoginActions.fetchVerifyLoginOtpError(response.response?.responseData);
                    }
                }),
                catchError(error => of(LoginActions.fetchVerifyLoginOtpError(error)))
            );
        })
    );
};

export const postUpdateUserPassword: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_UPDATE_USER_PASSWORD),
        mergeMap((action) => {
            return post(resolveURLParams(ENDPOINTS.POST_UPDATE_USER_PASSWORD, action.payload, null), action.payload, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response.response.operationMessage === 'failure') {
                        return LoginActions.fetchUpdateUserPasswordError();
                    } else if (response.status === 200) {
                        return LoginActions.fetchUpdateUserPasswordSuccess(response.response);
                    } else {
                        return LoginActions.fetchUpdateUserPasswordError();
                    }
                }),
                catchError(error => of(LoginActions.fetchUpdateUserPasswordError()))
            );
        })
    );
};

export const postUserLogin: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_USER_LOGIN),
        mergeMap((action) => {
            return post(resolveURLParams(ENDPOINTS.POST_USER_LOGIN, action.payload, null), action.payload, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response.response.operationMessage === 'failure') {
                        return LoginActions.fetchUserLoginError();
                    } else if (response.status === 200) {
                        return LoginActions.fetchUserLoginSuccess(response.response);
                    } else {
                        return LoginActions.fetchUserLoginError();
                    }
                }),
                catchError(error => of(LoginActions.fetchUserLoginError()))
            );
        })
    );
};
export const getPortfolioDetailsEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_PORTFOLIO_DETAILS),
        mergeMap((action) => {
            return getForMinorToken(resolveURLParams(ENDPOINTS.GET_PORTFOLIO_DETAILS, action.payload, null), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) {
                        console.log("portfolio details response",response.response.data)
                        return LoginActions.fetchgetPortfolioDetailsSuccess(response.response.data);
                    } 
                    else {
                        return LoginActions.fetchGetCheckMobileNumberError(response.response);
                    }
                }),
                catchError(error => of(LoginActions.fetchGetCheckMobileNumberError(error)))
            );
        })
    );
};